import React from 'react'

import useStyles from './styles'
import WidgetTitle from 'components/common/WidgetTitle/WidgetTitle'
import { WidgetContentHyperlink, WidgetContentItem } from 'data/Show'
import Carousel from 'react-multi-carousel'
import { Hidden } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { getCurtainValue } from 'redux/slices/curtain'
import { isCurtainOpen } from 'utils/curtain'
import clsx from 'clsx'

interface BuyWidgetProps {
    heading: string
    subHeading: string
    hyperlink: WidgetContentHyperlink
    items: WidgetContentItem[]
}

const responsive = {
    tablet: {
        breakpoint: { max: 767, min: 501 },
        items: 3,
        partialVisibilityGutter: 40,
    },
    sm: {
        breakpoint: { max: 500, min: 321 },
        items: 2,
        partialVisibilityGutter: 40,
    },
    xs: {
        breakpoint: { max: 320, min: 0 },
        items: 1,
    },
}

const BuyItem: React.FC<{ item: WidgetContentItem }> = ({ item }) => {
    const classes = useStyles()
    return (
        <div className={classes.item}>
            <div>
                <a href={item.callToActionUrl} target="_blank" rel="noopener noreferrer">
                    <img className={classes.image} src={item.imgUrl} alt={item.callToActionText} />
                </a>
            </div>
            <div>
                <h1 className={classes.title}>{item.callToActionText}</h1>
            </div>
        </div>
    )
}

const BuyWidget: React.FC<BuyWidgetProps> = ({ heading, subHeading, items, hyperlink }) => {
    const classes = useStyles()
    const curtainValue = useSelector(getCurtainValue)
    return (
        <div className={clsx(!isCurtainOpen(curtainValue) && classes.animateOnCurtainClosed)}>
            <WidgetTitle heading={heading} subHeading={subHeading} hyperlink={hyperlink} />
            <div className={classes.itemsContainer}>
                <Hidden mdUp>
                    <Carousel responsive={responsive} showDots={false}>
                        {items.map((item, index) => (
                            <BuyItem item={item} key={index} />
                        ))}
                    </Carousel>
                </Hidden>
                <Hidden smDown>
                    {items.map((item, index) => (
                        <BuyItem item={item} key={index} />
                    ))}
                </Hidden>
            </div>
        </div>
    )
}

export default React.memo(BuyWidget)
